import { Injectable } from '@angular/core';
import { DashboardFormsAnswersDetailItem, DashboardFormsAnswersResult, Form } from '@core/interfaces';
import { Apollo } from 'apollo-angular';
import gql from 'graphql-tag';

@Injectable({
  providedIn: 'root'
})
export class FormsReportService {
  constructor(private readonly apollo: Apollo) { }

  async accountFormsAnswers(where, options): Promise<any> {
    const items = await this.apollo
      .query({
        query: gql`
          query accountFormsAnswers(
            $where: DashboardFormsAnswersWhereInput!
            $limit: Int!
            $offset: Int!
          ) {
            accountFormsAnswers(where: $where limit: $limit offset: $offset) {
            totalCount
            items {
              formId
              formName
              formAnswerCount
            }
        }
      }`,
        variables: {
          where,
          offset: options.offset,
          limit: options.limit
        }
      })
      .toPromise()
      .then((result) => result.data['accountFormsAnswers'] as DashboardFormsAnswersResult);

    return items;
  }

  async getFormById(id: string): Promise<Form> {
    return await this.apollo
      .query({
        query: gql`
          query getForm($id: ID!) {
            form(id: $id) {
              id
              name
            }
          }
        `,
        variables: {
          id: id,
        }
      })
      .toPromise()
      .then((result) => result.data['form'] as Form);
  }

  async accountFormsAnswersDetail(where): Promise<DashboardFormsAnswersDetailItem[]> {
    return await this.apollo
      .query({
        query: gql`
          query accountFormsAnswersDetail($where: DashboardFormsAnswersDetailWhereInput!) {
            accountFormsAnswersDetail(where: $where) {
              items {
                title
                type
                position
                answers {
                  typeName: __typename
                  ... on ClosedQuestionAnswerStatistics {
                    value
                    count
                  }
                  ... on OpenQuestionAnswerStatistics {
                    value
                  }
                  ... on MultipleQuestionAnswerStatistics {
                    values
                  }
                }
              }
            }
          }`,
        variables: {
          where
        }
      })
      .toPromise()
      .then((result) => result.data['accountFormsAnswersDetail'].items as DashboardFormsAnswersDetailItem[]);
  }
}
